module.exports = {
    home:                         'Accueil',
    channels:                     'Chaînes',
    lastChannelUpdates:           'Dernières mises à jour de la chaîne',
    topics:                       'Sujets',
    noTitle:                      'Pas de titre',
    noDescription:                'Aucune description trouvée',
    imageMap:                     'Carte d\'image',
    de:                           'allemand',
    en:                           'anglais',
    contact:                      'Contact',
    imprint:                      'Mentions légales',
    legal:                        'Juridique',
    downloads:                    'Téléchargements',
    downloadTitle:                'Télécharger la vidéo :',
    downloadDescription:          '',
    directLinks:                  'Lien',
    directLinkTitle:              'Lien vidéo',
    directLinkDescription:        '',
    shortlink:                    'Lien court',
    //
    browseCategories:             'Sélectionner une catégorie',
    //
    prepareDownload:              'Préparation du téléchargement...',
    //
    contactPerson:                'Personne de contact',
    contactCompany:               'Société',
    contactOccupation:            'Profession',
    contactPhone:                 'Téléphone',
    contactEmail:                 'E-mail',
    mediahubTechError:            'Une erreur s\'est produite lorsque nous avons essayé d\'afficher cette page. Veuillez contacter la personne qui vous a envoyé ce lien.',
    mediahubNotYetAvailable:      'Cette page n\'est pas encore disponible. Veuillez la revisiter le ',
    mediahubNoLongerAvailable:    'Cette page n\'est plus disponible depuis le ',
    mediahubMaxDownloads:         'Le nombre maximal de demandes pour cette page a été atteint.',
    zoomTurnedOff:                'Activer le zoom d\'image',
    zoomTurnedOn:                 'Désactiver le zoom d\'image',
    // Informations supplémentaires
    additionalMedia:              'Téléchargements supplémentaires',
    additionalMediaContainer:     'Plus de vidéos sur',
    moreVideos:                   'Plus de vidéos',
    start:                        'Disponible à partir de :',
    end:                          'jusqu\'à :',
    // Authentification
    authenticationRequired:       'Authentification requise pour accéder à cette page.',
    authUsername:                 'Nom d\'utilisateur',
    authPassword:                 'Mot de passe',
    authLogin:                    'Connexion',
    authWrong:                    'Authentification incorrecte. Veuillez réessayer.',
    // Lié à la vidéo
    videoSize:                    'Taille',
    fileSize:                     'Taille du fichier',
    formatDownloads:              'Formats de téléchargement',
    download:                     'Télécharger',
    mediaNotAvailable:            'La vidéo n\'est pas disponible en téléchargement.',
    // Qualité de la vidéo
    hd:                           'HD',
    timeout:                      'La page a expiré.',
    timeoutDescription:           'Pour des raisons de sécurité, cette page n\'était valide que pendant une certaine période. Veuillez utiliser le bouton de rafraîchissement de votre navigateur pour revenir à la page.',
    noDataForMediaHub:            'Aucun fichier multimédia présent',
    noDataForMediaHubDescription: 'Aucun fichier multimédia n\'est connecté à ce mediahub.',
    mediahub:                     'MediaHub',
    loading:                      '...chargement',
    // Média
    title:                        'Titre',
    description:                  'Description',
    videoDescription:             'Description',
    mediaDescription:             'Description',
    // Recherche
    search:                       'Recherche',
    searchResults:                'Résultats',
    // Superposition du lecteur
    playerOverlayViews:           'Vues :',
    playerOverlayDate:            'Date :',
    playerOverlayTags:            'Tags :',
    // Fil d'Ariane
    breadcrumbYouAreHere:         'Vous êtes ici :',
    breadCrumbHomepage:           'Page d\'accueil',
    breadCrumbSlider:             'Dans le curseur',
    // Erreurs
    unauthorized:                 '401 - Non autorisé',
    forbidden:                    '403 - Interdit',
    notFound:                     '404 - L\'espace publicitaire n\'a pas pu être trouvé.',
    serverError:                  '500 - Erreur interne du serveur',
    error404p1:                   'La page que vous recherchez est introuvable.',
    error404p2:                   'Veuillez vérifier l\'adresse.',
    error404p3:                   'Pour plus d\'informations, veuillez nous contacter ',
    error404contact:              'ici',
    // Vide
    emptyString:                  ' ',
    backToOverview:               'Retour à l\'aperçu',
    showAll:                      'Afficher tout',
    showMore:                     'Afficher plus de vidéos',
    all:                          'Tout',
    filter_countEmbeds:           'Vidéos les plus vues',
    filter_createdAt:             'Dernières vidéos',
    filter_publishedDate:         'Dernières vidéos',
    noCreationDate:               'Pas de date de création',
    video:                        'Vidéos',
    watchVideo:                  'Regarder la vidéo',
    sharePost:                    'Partager cette vidéo',
  };
  